import { graphql } from 'gatsby';
import Cookies from 'js-cookie';
import React, { useEffect, useRef, useState } from 'react';

import MarketoForm from '../components/Common/MarketoForm/MarketoForm';
import RichTextConverter from '../components/Common/RichText/RichTextConverter';
import { scrollToFormTop } from '../components/Common/ScrollTo';
import Layout from '../components/Layouts/Layout';
import MarketingSeo from '../components/MarketingSeo';
import PageSection from '../components/PageSections/PageSection';
import * as styles from './simpleForm.module.scss';

const SimpleForm = ({ data, location, pageContext }) => {
  let page = {};
  if (data.page) page = data.page;
  const formContainerRef = useRef(null);
  const [submitted, setSubmitted] = useState(false);
  let featuredLogos,
    form = null;

  const onSuccess = () => {
    scrollToFormTop(formContainerRef);
    setSubmitted(true);
  };

  useEffect(() => {
    return () => {
      if (location.pathname.includes('/demo') && !submitted) {
        Cookies.set('fs-demo-leave', true);
      }
    };
  });

  page.pageSections.forEach((section) => {
    switch (section.__typename) {
      case 'ContentfulComponentMediaGroup':
        featuredLogos = (
          <div className={styles.logos} data-analytics-section={'logos'}>
            <p>{section.title}</p>
            <div className={styles.images} style={{}}>
              {section.media.map((logo, i) => {
                return (
                  <img
                    data-analytics-component={'logo'}
                    data-analytics-id={logo.title}
                    key={i}
                    loading="lazy"
                    src={logo.file.url}
                    alt={logo.title || ''}
                  />
                );
              })}
            </div>
          </div>
        );
        break;

      case 'ContentfulSectionMarketoForm':
        form = (
          <MarketoForm
            onSuccess={onSuccess}
            redirectUrl={section.onSuccessRedirectUrl}
            adCheckClass={styles.adCheck}
            className={styles.form}
            followUpForms={section?.followUpForms}
            formId={section?.marketoFormId}
            trackingPixelUrl={section.pageMetaData?.trackingPixelUrl}
            successMessage={section?.formSuccessMessage}
          />
        );
        break;

      default:
        break;
    }
  });

  return (
    <Layout pageMeta={page.pageMetaData} isDach={pageContext.isDach}>
      <PageSection isTopSection data-analytics-section={'simple-form-header'}>
        <div className={styles.grid} ref={formContainerRef}>
          <div className={styles.copy}>
            <h1 className={styles.headline}>{page.heading}</h1>
            <RichTextConverter copy={page.headingIntroCopy} />
            {featuredLogos}
          </div>
          {form}
        </div>
      </PageSection>
    </Layout>
  );
};

export default SimpleForm;

export const Head = ({ data: { page }, location }) => (
  <MarketingSeo meta={page.pageMetaData} slug={location.pathname} />
);

export const query = graphql`
  query SimpleFormTemplateQuery($slug: String!) {
    page: contentfulPageStandard(slug: { eq: $slug }) {
      ...StandardPage
    }
  }
`;
